'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import PagesList from './PagesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.parentPages.panel.${key}`;
const PagesSidePanel = ({
  pages,
  onClose
}) => /*#__PURE__*/_jsxs(UIPanel, {
  "data-selenium": "form-pages-panel",
  children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
    onClick: onClose
  }), /*#__PURE__*/_jsx(UIPanelHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('header')
      })
    })
  }), /*#__PURE__*/_jsx(UIPanelBody, {
    children: /*#__PURE__*/_jsx(UIPanelSection, {
      children: /*#__PURE__*/_jsx(PagesList, {
        pages: pages
      })
    })
  })]
});
export default PagesSidePanel;